<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true'  :modal-append-to-body='false'  :close-on-click-modal='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 分级公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                        div.width_label(v-if="ruleForm.ctType === 1") 常规赛
                        div.width_label(v-if="ruleForm.ctType === 2") 月度赛
                        div.width_label(v-if="ruleForm.ctType === 3") 季度赛
                        div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="比赛项目" prop="projectType")
                        div.width_label(v-if="ruleForm.projectType === 1") 单打
                        div.width_label(v-if="ruleForm.projectType === 2") 双打
                        div.width_label(v-if="ruleForm.projectType === 3") 双打配对赛
                el-form-item(label="级别" prop="level")
                        div.width_label {{ruleForm.level}}
                el-form-item(label="签位" prop="applySize")
                        div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                el-form-item(v-if="ruleForm.projectType === 3" label="人数" prop="applySize")
                        div.width_label {{enrollDataOne.length}}/{{ruleForm.applySize * 2}}
                br
                el-form-item(label="比赛时间")
                        div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                //- el-form-item(v-if="ruleForm.projectType === 2" label="排序")
                //-     el-select(v-model="ruleForm.orderForm" @change="orderChange")
                //-         el-option(label="按级别和-积分和" :value=1 )
                //-         el-option(label="按级别差-积分和" :value=2 )
            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-button(type="primary" @click="addEnrollView" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 添加人员
                    el-button(type="danger" @click="delEnroll" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
                    el-button(type="primary" @click="clickRefund" :disabled="ruleForm.matchStatus==4") 退 款
                    el-button(type="primary" @click="exportExcel") 名单导出
                    el-button(type="primary" @click="addEnrollView('wildCard')" :disabled="ruleForm.enrollDisabled || ruleForm.matchStatus == 4 || enrollDataOne.length >= (ruleForm.applySize * 2)") 发放外卡
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header" class="headTitle")
                        div
                            font.font_label 参赛人员
                        div
                            el-button(v-if='ruleForm.projectType == 3' type="primary" @click='openSortPair') 配对赛编排
                            el-button(type="primary" @click='openSortFormatr') 调整赛制
                            el-button(type="primary" @click='openSortNumber') 调整排序号
                      div
                        el-table(:data="enrollDataOne" border :span-method="enrollDataOneSpanMethod" @selection-change="enrollOneChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="sortNum" label="排序号" align='center' width='50')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="wildCards" label="报名方式" align='center')
                                    template(slot-scope="scope")
                                        font {{ (scope.row.wildCard == 1 || scope.row.wildCards == 1) ? '外卡报名' : '正常报名' }}
                                el-table-column( prop="gameNum" label="参赛次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.gameNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width="115")
                                el-table-column(prop="accountTypeName" label="账户属性" align='center' width="90")
                                el-table-column(prop="genderName" label="性别" align='center' width="60")
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="80")
                                el-table-column(prop="yearScore" label="积分" align='center' width='60')
                                //- el-table-column(prop="yearScore" label="积分" align='center' width='60' v-if="ruleForm.ctType==1 || ruleForm.ctType==4")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                //-         font(v-if="!scope.row.yearScore") 0/0
                                //- el-table-column(prop="monthScore" label="积分" align='center' width='60' v-if="ruleForm.ctType==2")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.monthScore") {{scope.row.monthScore}}
                                //-         font(v-if="!scope.row.monthScore") 0/0
                                //- el-table-column(prop="quarterScore" label="积分" align='center' width='60' v-if="ruleForm.ctType==3")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.quarterScore") {{scope.row.quarterScore}}
                                //-         font(v-if="!scope.row.quarterScore") 0/0
                                el-table-column( prop="enrollClubs" label="俱乐部赛参赛次数" align='center' width="80")
                                    template(slot-scope="scope")
                                        font {{ scope.row.enrollClubs || '-' }}
                                el-table-column(prop="memberTypeName" label="会员类型" align='center' width="90")
                                el-table-column(prop="signNo" label="签位号" align='center' width="50")
                                    template(slot-scope="scope")
                                        font {{ scope.row.signNo || '-' }}
                                //- el-table-column(prop="groupNo"  v-if='this.ruleForm.competitionMatchFormatList[0].matchFormat' label="组号" align='center' )
                                el-table-column(prop="payStatus" label="状态" align='center' width="100")
                                    template(slot-scope="scope")
                                        font {{ statusMap[scope.row.payStatus] }}
                                el-table-column(prop="payAmount" label="支付金额" align='center' width="100")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{ parseFloat(scope.row.payAmount).toFixed(2) }}元
                                el-table-column(prop="createTime" label="报名时间" align='center' width="100")
                                el-table-column(prop="byx2" label="报名方式" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="ruleForm.projectType === 3") {{ scope.row.byx2 == 1 ? '组队报名' : '个人参赛' }}
                                        font(v-else) -
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale") {{ scope.row.refundScale }}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee") ￥{{ parseFloat(scope.row.refundFee).toFixed(2) }}元
                                el-table-column(prop="refundDesc" label="退款说明" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.refundDesc }}
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group(style="min-width: 150px;")
                                                    el-menu-item(index="1-1" @click="updateBench(scope.row,1)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 设为替补
                                                    el-menu-item(index="1-5" @click="clickRefund(1,scope.row)" :disabled="ruleForm.matchStatus==4") 退款
                                                    el-menu-item(index="1-2" @click="delEnroll(1,scope.row)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
                                                    //- el-menu-item(index="1-3" @click="initDiaLogArgue(scope.row,1)" :disabled="ruleForm.matchStatus==4") 记录争议
                                                    el-menu-item(index="1-4" v-if="scope.row.argue !== null"  @click="initDiaLogArgue(scope.row,2)") 查看争议
                                                    el-menu-item(index="1-6" @click="viewParent(scope.row)" :disabled="scope.row.accountType=='0/0'") 查看家长        

            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-card(shadow="never")
                        div(slot="header")
                            font.font_label 替补人员
                        div
                            el-table(:data="enrollDataTwo" border :span-method="enrollDataTwoSpanMethod" @selection-change="enrollTwoChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(type="index" label="排序号" align='center' width='50')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="gameNum" label="参赛次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.gameNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width='115')
                                el-table-column(prop="accountTypeName" label="账户属性" align='center' width="90")
                                el-table-column(prop="genderName" label="性别" align='center' width='60')
                                el-table-column(prop="age" label="年龄" align='center' width='60')
                                el-table-column(prop="level" label="级别" align='center' width='80')
                                el-table-column(prop="yearScore" label="积分" align='center' width='60')
                                //- el-table-column(prop="yearScore" label="积分" align='center' width='60' v-if="ruleForm.orderForm === 1 || (ruleForm.orderForm === 2 && (ruleForm.ctType==1 || ruleForm.ctType==4))")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                //-         font(v-if="!scope.row.yearScore") 0/0
                                //- el-table-column(prop="monthScore" label="积分" align='center' width='60' v-if="ruleForm.orderForm === 2 && ruleForm.ctType==2")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.monthScore") {{scope.row.monthScore}}
                                //-         font(v-if="!scope.row.monthScore") 0/0
                                //- el-table-column(prop="quarterScore" label="积分" align='center' width='60' v-if="ruleForm.orderForm === 2 && ruleForm.ctType==3")
                                //-     template(slot-scope="scope")
                                //-         font(v-if="scope.row.quarterScore") {{scope.row.quarterScore}}
                                //-         font(v-if="!scope.row.quarterScore") 0/0
                                el-table-column(prop="enrollClubs" label="俱乐部赛参赛次数" align='center' width="80")
                                    template(slot-scope="scope")
                                        font {{ scope.row.enrollClubs || '-' }}
                                el-table-column(prop="memberTypeName" label="会员类型" align='center' width='90')
                                el-table-column(prop="signNo" label="签位号" align='center' width="50")
                                    template(slot-scope="scope")
                                        font {{ scope.row.signNo || '-' }}
                                //- el-table-column(prop="name" label="签位号（？）" align='center')
                                el-table-column(prop="payStatus" label="状态" align='center' width='100')
                                    template(slot-scope="scope")
                                        font {{ statusMap[scope.row.payStatus] || '-' }}
                                el-table-column(prop="payAmount" label="支付金额" align='center' width="100")
                                    template(slot-scope="scope")
                                        font {{ scope.row.payAmount ? `￥${parseFloat(scope.row.payAmount).toFixed(2)}元` : '-' }}
                                el-table-column(prop="createTime" label="报名时间" align='center' width='100')
                                el-table-column(prop="byx2" label="报名方式" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="ruleForm.projectType === 3") {{ scope.row.byx2 == 1 ? '组队报名' : '个人参赛' }}
                                        font(v-else) -
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale") {{ scope.row.refundScale }}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee") ￥{{ parseFloat(scope.row.refundFee).toFixed(2) }}元
                                el-table-column(prop="refundDesc" label="退款说明" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.refundDesc }}
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="2")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group(style="min-width: 150px;")
                                                    el-menu-item(index="2-1" @click="updateBench(scope.row,0)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 设为参赛
                                                    el-menu-item(index="2-2" @click="delEnroll(1,scope.row)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
            el-row(style="padding-top:10px")
                el-col(:span="24")
                    el-card(shadow="never")
                        div(slot="header")
                            font.font_label 场地信息录入
                        div
                            //- el-table(:data="gradeData" border)
                            //-     el-table-column(prop="name" label="姓名" align="center")
                            //-     el-table-column(prop="mobile" label="手机号" align="center")
                            //-     el-table-column(prop="rank" label="排名" align="center")
                            //-         template(slot-scope="scope")
                            //-             el-input-number(v-model="scope.row.rank" :min="0")
                            //-     el-table-column(prop="score" label="积分" align="center" :min="0")
                            //-         template(slot-scope="scope")
                            //-             el-input-number(v-model="scope.row.score")
                            //- 二期改造内容,暂时先屏蔽
                            div(class="marginBottom")
                                el-button(@click="chooseRound(item)" v-for='(item,index) in roundList' :type="primary===item?'primary':''") {{item}}R
                            el-table( :data="matchTableData" border :span-method="objectSpanMethod")
                              el-table-column(prop="matchTime" label="比赛时间" align="center" width='200')
                              el-table-column(prop="signNum" label="签位号" align="center")
                              //- el-table-column(prop="secondGroup"  v-if='this.ruleForm.competitionMatchFormatList[0].matchFormat' label="组号" align='center' )
                              //-   template(slot-scope="scope")
                              //-       font(v-if="scope.row.secondGroup == -1?fasle:true") {{scope.row.secondGroup}}
                              el-table-column(prop="name" label="姓名" align="center")
                              el-table-column(prop="memberAccount" label="会员账号" align="center")
                              el-table-column(prop="sex" label="性别" align="center")
                              el-table-column(prop="age" label="年龄" align="center")
                              el-table-column(prop="level" label="级别" align="center")
                              el-table-column(prop="competitionTerrain" label="场地号" align="center")
            el-dialog(:title="`添加${wildCard ? '外卡' : '人员'}`"  :visible.sync="addVisible" width="80%" :append-to-body='true' :modal-append-to-body='false' :close-on-click-modal='false')
                el-row
                   el-col(:span="11")
                      el-card(shadow="never")
                        div(slot="header")
                            el-row
                                el-col(:span='22')
                                    el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                                el-col(:span='2')
                                    el-button(@click="getLeftData" style='float:right;' icon='el-icon-search') 查询
                        div
                          el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="gender" label="性别" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="mobile" label="手机号码" align='center' )
                              el-table-column(prop="idCard" label="身份证号" align='center'  )
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                          el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
                   el-col(:span="2")
                      div.opSetting
                          div(@click="handelSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                          div.spacing(@click="handleRemoveSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
                   el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已选择的{{ wildCard ? '外卡' : '会员' }}
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                                    el-table-column(type="selection" align='center')
                                    el-table-column(prop="name" label="姓名" align='center')
                                    el-table-column(prop="gender" label="性别" align='center' )
                                        template(slot-scope="scope")
                                            font(v-if="scope.row.gender === 0") 男
                                            font(v-if="scope.row.gender === 1") 女
                                    el-table-column(prop="level" label="级别" align='center' )
                                    el-table-column(prop="mobile" label="手机号码" align='center' )
                                    el-table-column(prop="idCard" label="身份证号" align='center'  )
                                    el-table-column(prop="accountType" label="账户属性" align='center'  )
                                      template(slot-scope="scope")
                                        font(v-if="scope.row.accountType === 0") 一般账户
                                        font(v-if="scope.row.accountType === 1") 青少年账户
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="addVisible=false") 取 消
            el-dialog(title="查看家长"  :visible.sync="viewParentVisible" width="50%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="24")
                        div
                          el-table(:data="parentList" border  @selection-change="checkAll" max-height="300")
                              //- el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="mobile" label="会员账号" align='center')
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="type" label="会员类型" align='center' width="130")
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.type == 1") 注册会员
                                    font(v-if="scope.row.type == 2") 初始会员
                                    font(v-if="scope.row.type == 3") 荣誉会员
            //争议弹框
            el-dialog(:title="argueTitle" :visible.sync="argueVisible" :append-to-body='true' :modal-append-to-body='false'  :close-on-click-modal='false' )
                div(v-if="addOrViewArgue" style="margin-top:-27px;")
                    el-input(v-model="argueForm.argue" type="textarea" :rows="10" resize="none"  placeholder="请输争议内容")
                div(v-if="!addOrViewArgue" style="min-height:160px;") {{argueForm.argue}}
                span.dialog-footer(slot="footer")
                    el-button(v-if="addOrViewArgue" @click="comfirmArgue" type="primary") 确 定
                    el-button(@click="argueVisible=false") 取 消
            el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false' :close-on-click-modal='false')
                el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                    el-row
                       el-col(:span="8")
                            div(style="float:right")
                              el-radio(v-model="radio" label="1" border) 按比例退款
                       el-col(:span="16")
                            el-form-item(prop="refundScale" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==1 ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                    el-row
                        el-col(:span="8")
                            div(style="float:right")
                                el-radio(v-model="radio" label="2" border) 按固定金额退款
                        el-col(:span="16")
                            el-form-item(prop="refundFee" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==2 ? false : true" v-model="refundForm.refundFee" :min=0 :max="refundFeeMax" :precision="2" )
                    el-row
                        el-col(:span="8" style="margin-right:26px")
                            div(style="text-align:right;margin-right:-14px") 退款说明：
                        el-col(:span="8")
                            el-input(v-model="refundForm.refundDesc" type="textarea" :rows=6 resize="none" maxlength="99" show-word-limit)
                span.dialog-footer(slot="footer")
                    el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定
                    el-button(@click="refundVisible=false") 取 消
        SortNumber(v-if='SortNumberVisible', ref="SortBmber",@refreshSortFormatrList='SortFormatrList')
        SortFormat(v-if='SortFormatrVisible', ref="SortFormatr" @refreshSortFormatrList='SortFormatrList')
        SortPair(v-if='SortPairVisible', ref="SortPair" @refreshSortFormatrList='SortFormatrList')
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import table from './table.js'
import SortNumber from './SortNumber'
import SortFormat from './SortFormat'
import SortPair from './SortPair'
export default {
  data() {
    return {
      primary: 1,
      isRoundView: false,
      SortFormatrVisible: false,
      SortNumberVisible: false,
      SortPairVisible: false,
      isCollapse: true,
      table: {
        columns: table.columns,
        columnsDoubleQuarter: table.columnsDoubleQuarter,
        columnsDoubleMonth: table.columnsDoubleMonth,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      refundBtn: false,
      argueVisible: false,
      addOrViewArgue: true,
      argueTitle: '',
      argueForm: {
        argue: ''
      },
      gradeData: [],
      refundList: [],
      regMember: '', //注册会员
      initMember: '', //初始化会员
      honour: '', //荣誉会员
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      memberName: '',
      buttonSize: 'large',
      options: [],
      value: '',
      leftData: [],
      rightData: [], // 右边列表
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      visible: false,
      addVisible: false,
      wildCard: null,
      viewParentVisible: false,
      parentList: [],
      refundVisible: false,
      title: '参赛人员管理',
      enrollData: [],
      enrollDataOne: [],
      enrollDataTwo: [],
      enrollDataChange: [],
      enrollDataOneChange: [],
      enrollDataTwoChange: [],
      ruleForm: {
        id: '',
        ctId: '',
        matchName: '',
        orgId: '',
        city: '',
        province: '',
        placeId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: '1',
        applyDate: [],
        matchSignStartTime: '',
        matchSignEndTime: '',
        matchStartTime: '',
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: '0',
        genderLimit: '2',
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: '',
        competitionMatchFormatList: [{
          matchFormat: 0
        }],
        ctRefundList: [],
        byx1: '',
        verifyReason: '',
        orderForm: 1,
        enrollDisabled: true
      },
      enrollList: {
        ctId: '',
        bench: '0', //是否替补队员 0:否 1:是
        matchType: 1, //业务类型（1分级赛、2俱乐部）,
        mbMemberList: []
      },
      payRefund: null,
      refundForm: {
        refundScale: undefined,
        refundFee: undefined,
        refundDesc: ''
      },
      radio: undefined,
      loading: null,
      refundFeeMax: 0,
      roundList: [],
      matchTableData: [], // 对阵表数据
      playUsers: [], // 对阵人员
      isActive: 0, // 动态显示按钮颜色
      statusMap: {
        0: '未缴费',
        1: '支付中',
        2: '已缴费',
        3: '支付失败',
        4: '超时',
        5: '申请退款',
        6: '退款中',
        7: '退款成功',
        8: '退款失败',
        9: '支付已关闭',
        10: '退款已取消',
      },
    }
  },
  components: {
    SortNumber,
    SortFormat,
    SortPair
  },
  methods: {
    // 参赛人员单元格合并
    enrollDataOneSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只有"双打配对赛"才会合并单元格
      if (this.ruleForm.projectType !== 3) return
      // "组队参赛"需要合并的单元格
      if (columnIndex === 0 || (columnIndex >= 12 && columnIndex <= 19)) {
        // 下一行存在 && 当前行是"组队参赛" && 当前行不是被合并的那一行 => 代表这一行需要把下一行合并了
        if (this.enrollDataOne[rowIndex + 1] && this.enrollDataOne[rowIndex].byx2 == 1 && !this.enrollDataOne[rowIndex].__IsByx2Merge__) {
          // 把下一行也就是他队友的id记录下来, 批量删除时会用到
          this.enrollDataOne[rowIndex].__teammateId__ = this.enrollDataOne[rowIndex + 1].id
          // 给下一行打上标记, 循环到下一行时根据标记来判断该行是否已经被合并
          this.enrollDataOne[rowIndex + 1].__IsByx2Merge__ = true
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (this.enrollDataOne[rowIndex].__IsByx2Merge__) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      // "分组"合并
      if (columnIndex === 1) {
        // 下一行存在 && 当前行的对阵序号和下一行相同 => 代表这一行和下一行是同一组
        if (this.enrollDataOne[rowIndex + 1] && this.enrollDataOne[rowIndex].sortNum === this.enrollDataOne[rowIndex + 1].sortNum) {
          // 给下一行打上标记, 循环到下一行时根据标记来判断该行是否已经被合并
          this.enrollDataOne[rowIndex + 1].__IsSortNumMerge__ = true
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (this.enrollDataOne[rowIndex].__IsSortNumMerge__) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // 替补人员单元格合并
    enrollDataTwoSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只有"双打配对赛"才会合并单元格
      if (this.ruleForm.projectType !== 3) return
      // "组队参赛"需要合并的单元格
      if (columnIndex === 0 || (columnIndex >= 12 && columnIndex <= 19)) {
        // 下一行存在 && 当前行是"组队参赛" && 当前行不是被合并的那一行 => 代表这一行需要把下一行合并了
        if (this.enrollDataTwo[rowIndex + 1] && this.enrollDataTwo[rowIndex].byx2 == 1 && !this.enrollDataTwo[rowIndex].__IsByx2Merge__) {
          // 把下一行也就是他队友的id记录下来, 批量删除时会用到
          this.enrollDataTwo[rowIndex].__teammateId__ = this.enrollDataTwo[rowIndex + 1].id
          // 给下一行打上标记, 循环到下一行时根据标记来判断该行是否已经被合并
          this.enrollDataTwo[rowIndex + 1].__IsByx2Merge__ = true
          return {
            rowspan: 2,
            colspan: 1
          }
        } else if (this.enrollDataTwo[rowIndex].__IsByx2Merge__) {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // 获取伦次
    Round() {
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/operation/player-manage/against-list/rounds/${this.ruleForm.id}`
        ),
        method: 'get'
      }).then((data) => {
        if (data && data.code === 0) {
          // this.matchTableData = data.data // array
          if (data.data !== null) {
            this.isRoundView = true
            this.roundList = []
            let round = data.data * 1
            for (var i = 0; i < round; i++) {
              this.roundList.push(i + 1)
            }
            this.primary = this.roundList[0]
            this.AgainstPlan()
          } else {
            this.roundList = []
            this.isRoundView = false
            this.matchTableData = []
          }
        }
      })
    },
    // 获取对阵表
    AgainstPlan() {
      this.matchTableData = []
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/operation/player-manage/against-list/grade/` + this.ruleForm.id
        ),
        method: 'get',
        params: {
          round: this.primary
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.matchTableData = []
          let arr = data.data.infoList
          for (var i = 0; i < arr.length; i++) {
            for (var j = 0; j < arr[i].playerList.length; j++) {
              arr[i].playerList[j].againstId = arr[i].againstId
              arr[i].playerList[j].matchTime = arr[i].matchTime == null ? arr[i].matchTime : this.getMyDate(arr[i].matchTime)
              arr[i].playerList[j].secondGroup = arr[i].secondGroup
              arr[i].playerList[j].competitionTerrain = arr[i].competitionTerrain
              arr[i].playerList[j].memberAccount = arr[i].playerList[j].memberAccount === "null" ? "" : arr[i].playerList[j].memberAccount
              this.matchTableData.push(arr[i].playerList[j])
            }
          }
          console.log(this.matchTableData)
          // this.matchTableData = data.data // array
        } else {
          this.matchTableData = []
        }
      })
    },
    // 时间转换
    getMyDate(str) {
      let oDate = new Date(str)
      let oYear = oDate.getFullYear()
      let oMonth = oDate.getMonth() + 1
      let oDay = oDate.getDate()
      let oHour = oDate.getHours()
      let oMin = oDate.getMinutes()
      let oSen = oDate.getSeconds()
      let oTime = oYear + '-' + this.addZero(oMonth) + '-' + this.addZero(oDay) + ' ' + this.addZero(oHour) + ':' + this.addZero(oMin) + ':' + this.addZero(oSen)
      return oTime
    },
    addZero(num) {
      if (parseInt(num) < 10) {
        num = '0' + num
      }
      return num
    },
    // 成绩管理录入数据查看事件
    chooseRound(type) {
      this.primary = type
      this.AgainstPlan()
    },
    // 调整序列号
    openSortNumber() {
      this.SortNumberVisible = true
      this.$nextTick(() => {
        this.$refs.SortBmber.init(
          this.enrollDataOne,
          this.ruleForm.id,
          this.ruleForm.projectType,
          'double'
        )
      })
    },
    SortFormatrList() {
      this.init(this.ruleForm.id)
    },
    choseSortBmber() {
      this.SortNumberVisible = false
    },
    // 配对编排赛
    openSortPair() {
      this.SortPairVisible = true
      this.$nextTick(() => {
        this.$refs.SortPair.init(this.ruleForm.id)
      })
    },
    // 调整赛制
    openSortFormatr() {
      this.SortFormatrVisible = true
      this.$nextTick(() => {
        this.$refs.SortFormatr.init(this.ruleForm.id, 2)
      })
    },
    //刷新添加人员左边table
    getLeftData() {
      let arrId = []
      for (let i of this.enrollData) {
        arrId.push(i.mbId)
      }
      for (let i of this.rightData) {
        arrId.push(i.id)
        console.log(i.id)
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberList`),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.memberName,
          status: 1, //只查询已实名认证的会员
          ids: arrId.join()
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.list.rows
          this.totalPage = data.list.total
        } else {
          this.leftData = []
          this.totalPage = 0
        }
      })
    },
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //添加人员入库
    addEnroll() {
      if (this.rightData.length === 0) {
        return this.$message.error('没有要添加的会员!')
      }
      // 双打模式下, 选择的会员数量必须是偶数
      if (this.ruleForm.projectType == 2 && this.rightData.length % 2 != 0) {
        return this.$message.error('选择的会员数量必须是偶数!')
      }
      this.openFullScreen()
      if (this.wildCard) {
        this.enrollList.wildCard = this.wildCard
      }
      this.enrollList.mbMemberList = []
      this.rightData.forEach((data) => {
        let orderFee = ''
        if (data.type === 1) {
          orderFee = this.regMember
        } else if (data.type === 2) {
          orderFee = this.initMember
        } else if (data.type === 3) {
          orderFee = this.honour
        }
        this.enrollList.mbMemberList.push({
          id: data.id,
          name: data.name,
          type: data.type,
          orderFee: orderFee,
          level: data.level,
          mobile: data.mobile,
          accountType: data.accountType
        })
      })

      //先验证每个会员是否满足当前赛事报名条件
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/checkEnrollMember`),
        method: 'post',
        data: this.enrollList
      }).then((data) => {
        console.log(data)
        if (data && data.code === 0) {
          if (data.state) {
            console.log('验证通过')
            this.$http({
              url: this.$http.adornUrl(`/elEnroll/save`),
              method: 'post',
              data: this.enrollList
            }).then((data) => {
              console.log(data)
              if (data && data.code === 0) {
                this.$message.success('添加成功!')
                this.addVisible = false
                this.init(this.ruleForm.id)
              } else {
                this.$message.success('添加失败!')
              }
              this.loading.close()
            })
          } else {
            this.$message.error(data.info)
          }
        }
        this.loading.close()
      })
    },
    //添加人员页面
    addEnrollView(wildCard) {
      this.addVisible = true
      this.memberName = ''
      this.rightData = []
      this.enrollList = {}
      this.nowSelectRightData = [] // 右边选中列表数据
      this.enrollList.ctId = this.ruleForm.id
      // 外卡
      if (wildCard === 'wildCard') {
        this.wildCard = 1
      } else {
        this.wildCard = null
      }
      this.getLeftData()
    },
    initEnrollDataChange() {
      this.enrollDataChange = []
      if (
        this.enrollDataOneChange.length === 0 &&
        this.enrollDataTwoChange.length === 0
      ) {
        this.$message.error('提示：请勾选要操作的人员！')
        return true
      }
      this.enrollDataChange = this.enrollDataOneChange.concat(
        this.enrollDataTwoChange
      )
      return false
    },
    //退款弹窗事件
    clickRefund(btn, row) {
      console.log('退款按钮：', row)
      this.radio = undefined
      this.payRefund = {}
      //支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
      if (btn == 1) {
        //操作栏退款
        let payStatus = row.payStatus
        if (
          payStatus == 0 ||
          payStatus == 1 ||
          payStatus == 3 ||
          payStatus == 4
        ) {
          this.$message.error('提示：未缴费不能退款！')
          return
        }
        if (payStatus == 5) {
          this.$message.error('提示：已发起退款申请！')
          return
        }
        if (payStatus == 6 || payStatus == 8) {
          this.$message.error('提示：退款中！')
          return
        }
        if (payStatus == 7) {
          this.$message.error('提示：已完成退款！')
          return
        }
        if (this.ruleForm.projectType === 3) {
          this.payRefund.orderIds = row.orderId
        } else {
          this.payRefund.ids = row.id
        }
        this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
      } else {
        //批量退款
        // this.payRefund = null
        //替补人员不需要退费操作
        if (this.enrollDataOneChange.length === 0) {
          this.$message.error('提示：请勾选要退费的人员！')
          return
        }
        // if(this.enrollDataChange.length > 1){
        //     this.$message.error("提示：退款只能选择一个人员！")
        //     return
        // }
        // let enroll = this.enrollDataOneChange.length > 0 ? this.enrollDataOneChange : this.enrollDataTwoChange
        // this.payRefund = enroll[0]
        console.log('勾选的退款人员', this.enrollDataOneChange)
        let feeFlag = false
        let feeInfo = ''
        let idArr = []
        this.refundFeeMax = parseFloat(
          this.enrollDataOneChange[0].payAmount
        ).toFixed(2)
        this.enrollDataOneChange.forEach((row) => {
          if (
            row.payStatus == 0 ||
            row.payStatus == 1 ||
            row.payStatus == 3 ||
            row.payStatus == 4
          ) {
            feeInfo = '提示：未缴费不能退款！'
            feeFlag = true
            return
          }
          if (row.payStatus == 5) {
            feeInfo = '提示：已发起退款申请！'
            feeFlag = true
            return
          }
          if (row.payStatus == 6 || row.payStatus == 8) {
            feeInfo = '提示：退款中！'
            feeFlag = true
            return
          }
          if (row.payStatus == 7) {
            feeInfo = '提示：已完成退款！'
            feeFlag = true
            return
          }
          if (this.ruleForm.projectType === 3) {
            idArr.push(row.orderId)
          } else {
            idArr.push(row.id)
          }
          //退款金额赋最大值
          if (this.refundFeeMax > parseFloat(row.payAmount).toFixed(2)) {
            this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
          }
        })
        if (feeFlag) {
          this.$message.error(feeInfo)
          return
        }
        if (this.ruleForm.projectType === 3) {
          this.payRefund.orderIds = idArr.toString()
        } else {
          this.payRefund.ids = idArr.toString()
        }
      }
      this.refundVisible = true
      this.refundForm.refundScale = undefined
      this.refundForm.refundFee = undefined
      this.refundForm.refundDesc = ''
      this.refundFeeMax = parseFloat(this.refundFeeMax)
    },
    //初始化记录争议弹框
    initDiaLogArgue(row, val) {
      this.argueVisible = true
      this.argueForm.id = ''
      if (val === 1) {
        this.argueForm.argue = row.argue || ''
        this.addOrViewArgue = true
        this.argueTitle = '记录争议内容'
        this.argueForm.id = row.id
      } else {
        this.argueForm.argue = row.argue || '无争议!'
        this.addOrViewArgue = false
        this.argueTitle = '查看争议'
      }
    },
    //记录争议提交事件
    comfirmArgue() {
      // if (this.argueForm.argue.length === 0) {
      //     this.$message.error('争议内容不能为空！')
      //     return
      // }
      if (this.argueForm.argue.length > 500) {
        this.$message.error('争议内容长度不能超过500个字符')
        return
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/update`),
        method: 'post',
        data: this.argueForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.argueVisible = false
          this.getEnrollData(this.ruleForm.id)
        }
      })
    },
    //退款提交事件
    comfirmRefundRee() {
      console.log('退款信息：', this.refundForm)
      if (this.radio === undefined) {
        this.$message.error('请选择按比例或者固定金额退款!')
        return
      }
      if (this.radio == 1) {
        if (!this.refundForm.refundScale) {
          this.$message.error('请填写退款比例!')
          return
        } else {
          this.payRefund.refundScale = this.refundForm.refundScale
          this.payRefund.refundFee = undefined
          this.refundForm.refundFee = undefined
        }
      }
      if (this.radio == 2) {
        if (!this.refundForm.refundFee) {
          this.$message.error('请填写固定金额退款!')
          return
        } else {
          this.payRefund.refundFee = this.refundForm.refundFee
          this.payRefund.refundScale = undefined
          this.refundForm.refundScale = undefined
        }
      }
      console.log('退款确定：', this.payRefund)
      this.refundBtn = true
      this.payRefund.refundDesc = this.refundForm.refundDesc // 退款说明
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/refund`),
        method: 'post',
        data: this.payRefund
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.refundVisible = false
          this.getEnrollData(this.ruleForm.id)
        }
      }).finally(() => {
        this.refundBtn = false
      })
    },
    //设置替补或主力
    // type: 0主力  1替补
    updateBench(row, type) {
      let title = type === 0 ? '是否设置为参赛人员？' : '是否设置为替补人员？'
      if (type === 1) {
        //设为替补，先判断
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
        if (row.wildCard === 1) {
          return this.$message.error('外卡人员不能设置为替补人员！')
        }
      }

      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          row.bench = type
          let httpUrl = ''
          let httpMethod = 'post'
          let httpData = {}
          if (this.ruleForm.projectType === 3) {
            httpMethod = 'get'
            httpUrl = `/elEnroll/updateByEnrollBenchDoubleMatch?ctId=${row.ctId}&enrollOrderId=${row.id}&bench=${type}`
          } else {
            httpUrl = '/elEnroll/updateByEnrollBenchDouble'
            httpData = row
          }
          this.$http({
            url: this.$http.adornUrl(httpUrl),
            method: httpMethod,
            data: httpData
          }).then((data) => {
            if (data && data.code === 0) {
              if (data.state) {
                this.$message.success('操作成功!')
                this.init(this.ruleForm.id)
              } else {
                this.$message.error(data.info)
              }
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    //删除人员
    delEnroll(btn, row) {
      let idArr = []
      if (btn == 1) {
        //单个删除
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
        if (row.__teammateId__) {
          idArr.push(...[row.id, row.__teammateId__])
        } else {
          idArr.push(row.id)
        }
      } else {
        //批量删除
        if (this.initEnrollDataChange()) {
          return
        }
        this.enrollDataChange.forEach((i) => {
          if (
            i.payStatus === 2 ||
            i.payStatus === 5 ||
            i.payStatus === 6 ||
            i.payStatus === 8 ||
            i.payStatus === 10
          ) {
            this.$message.error('提示：【' + i.name + '】请先进行退费操作!')
          } else {
            if (i.__teammateId__) {
              idArr.push(...[i.id, i.__teammateId__])
            } else {
              idArr.push(i.id)
            }
          }
        })

        // for (let i of this.enrollDataChange) {
        //     if (i.payStatus === 2 || i.payStatus === 5 || i.payStatus === 6 || row.payStatus === 8 || i.payStatus === 10) {
        //         this.$message.error('提示：请先进行退费操作!')
        //         return
        //     }
        //     idArr.push(i.id)
        // }
      }
      console.log('要删除的参赛人员：', idArr.toString())
      this.$confirm('是否删除该人员', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          let httpUrl = ''
          if (this.ruleForm.projectType === 3) {
            httpUrl = '/elEnroll/deleteByDoubleMatchEnroll'
          } else {
            httpUrl = '/elEnroll/deleteByEnroll'
          }
          this.$http({
            url: this.$http.adornUrl(httpUrl),
            method: 'post',
            params: this.$http.adornParams({
              ids: idArr.join()
            })
          }).then((data) => {
            if (data && data.code === 0) {
              if (data.state) {
                this.$message.success('删除成功')
                this.init(this.ruleForm.id)
              } else {
                this.$message.error(data.info)
              }
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },

    // 查看家长
    viewParent(row) {
      console.log(row)
      this.viewParentVisible = true
      let data = {
        bindMbIds: row.doubleMbId.split('/')
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getParentMembersByTeen`),
        method: 'post',
        data
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('家长列表', data)
          this.parentList = data.data
        }
      })
    },
    init(id) {
      this.ruleForm.id = id
      this.radio = undefined
      this.visible = true
      this.primary = 1
      this.regMember = ''
      this.initMember = ''
      this.honour = ''
      this.enrollData = []
      this.enrollDataOne = []
      this.enrollDataTwo = []
      this.enrollDataChange = []
      this.enrollDataOneChange = []
      this.enrollDataTwoChange = []

      //回显
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
        method: 'get'
      })
        .then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.bean
            console.log('竞赛信息：', data.bean)
            if (this.ruleForm.projectType == 1) {
              //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
              this.ruleForm.orderForm = 0
            } else if (this.ruleForm.projectType == 2) {
              //双打默认按级别和-积分和排序
              this.ruleForm.orderForm = 1
            }
            let joinCount = this.ruleForm.joinCount //已报名参赛人员的人数
            let applySize = this.ruleForm.applySize //赛事签位数
            let date1 = new Date().getTime()
            let date2 = new Date(this.ruleForm.matchStartTime).getTime()
            let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
            let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
            this.ruleForm.enrollDisabled = true
            if (date1 < date3) {
              this.ruleForm.statusName = '未开始'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount < applySize
            ) {
              this.ruleForm.statusName = '报名中'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize &&
              this.ruleForm.bench === 1
            ) {
              this.ruleForm.statusName = '报满可替'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize &&
              this.ruleForm.bench === 0
            ) {
              this.ruleForm.statusName = '已报满'
              this.ruleForm.enrollDisabled = false
            } else if (date1 > date4 && date1 < date2) {
              this.ruleForm.statusName = '报名结束'
              this.ruleForm.enrollDisabled = false
            } else if (date1 >= date2) {
              this.ruleForm.statusName = '已开赛'
              this.ruleForm.enrollDisabled = true
            }
            this.refundList = data.rList
            for (let i of data.eList) {
              if (i.type === 1) {
                this.regMember = i.price
              } else if (i.type === 2) {
                this.initMember = i.price
              } else if (i.type === 3) {
                this.honour = i.price
              }
            }
          }
        })
        .then(() => {
          this.getEnrollData(id)
          // 获取对阵表数据
          // this.getMatchTableData(id)
        })
      this.Round()
    },
    /**
     * 与当前时间比较 返回小时
     * @param date2
     * @returns {number}
     */
    getDateDiff(date2) {
      let startDate = new Date(date2)
      let endDate = new Date()
      if (startDate.getTime() > endDate.getTime()) {
        let hour = (startDate.getTime() - endDate.getTime()) / 1000 / 60 / 60
        return hour
      } else {
        return -1
      }
    },
    orderChange() {
      this.getEnrollData1(this.ruleForm.id)
    },
    // 参赛人员管理-对阵表信息
    // getMatchTableData (id) {
    //   this.$http({
    //     url: this.$http.adornUrl(
    //       `/ctCompetition/operation/player-manage/against-list/${id}`
    //     ),
    //     method: 'get'
    //   }).then((data) => {
    //     if (data && data.data.code === 0) {
    //       this.matchTableData = data.data
    //     }
    //   })
    // },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let { property } = column;
      if (property === 'matchTime' || property === 'competitionTerrain') {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // // 点击选择对阵表查看
    // chooseRound (round, index) {
    //   this.isActive = index
    //   this.matchTableData.forEach((e) => {
    //     if (e.round === round) {
    //       e.infoList.map((ele) => {
    //         ele.playerList.map((item) => {
    //           item.matchTime = ele.matchTime
    //           item.groupId = ele.groupId
    //           this.playUsers.push(item)
    //         })
    //       })
    //     }
    //   })
    // },
    // 合并对阵表单元格
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getEnrollData1(id) {
      let params = {
        ctId: id,
        ctType: this.ruleForm.ctType,
        orderForm: this.ruleForm.orderForm //双打默认按级别和-积分和排序
      }
      //关于排序（当比赛项目为双打时）：提供两种排序方式：
      // （1）按级别和-积分和排序，两名同组参赛人员级别之和大的排在前面，级别和相同的情况下，年度积分之和大的排在前面。
      // （2）按级别差-积分和排序，两名同组参赛人员级别之差小的排在前面，级别差相同的情况下，积分之和（
      // 常规赛按照年度积分和计算、月赛按照今天之前30天积分和统计、季赛按照今天之前90天统计、年赛按照今天之前365天统计）大的排在前面。
      //比赛类型(1常规赛，2月度赛，3季度赛，4年度总决赛，5月度赛-资格赛，6月度赛-级别赛)

      this.$http({
        url: this.$http.adornUrl(`/elEnroll/changeSortOrder`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/getDoubleEnrollListByCtId`),
          method: 'post',
          params: this.$http.adornParams(params)
        }).then((data) => {
          if (data && data.code === 0) {
            // console.log('参赛人员列表：', data)
            this.enrollData = data.eoList
            this.table.data = data.list
            console.log(this.table.data);
            
            // this.enrollDataOne = []
            // this.enrollDataTwo = []
            for (let i of this.table.data) {
              if (i.refundScale === null && i.refundFee !== null) {
                i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
              }
              if (i.refundFee === null && i.refundScale !== null) {
                i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
              }
              if (i.gender) {
                let arr = i.gender.split('/')
                let arrName = []
                arr.forEach((g) => {
                  arrName.push({ '0': '男', '1': '女' }[g])
                })
                i.genderName = arrName.join('/')
              }
              if (i.memberType) {
                let arr = i.memberType.split('/')
                let arrName = []
                arr.forEach((g) => {
                  arrName.push(
                    { '1': '注册会员', '2': '初始会员', '3': '荣誉会员' }[g]
                  )
                })
                i.memberTypeName = arrName.join('/')
              }
              if (i.mbBirthday) {
                i.birthday = i.mbBirthday
              }
              if (i.birthdays) {
                i.birthday = i.birthdays
              }
              if (i.idCards) {
                i.idCard = i.idCards
              }
              console.log(i.bench, 'i.bench');

              if (i.bench === 0) {
                //主力
                this.enrollDataOne.push(i)
              }
              if (i.bench === 1) {
                //替补
                this.enrollDataTwo.push(i)
              }
            }
          }
        })
      })
    },
    //列表刷新
    getEnrollData(id) {
      let params = {
        ctId: id,
        ctType: this.ruleForm.ctType,
        orderForm: this.ruleForm.orderForm //双打默认按级别和-积分和排序
      }
      //关于排序（当比赛项目为双打时）：提供两种排序方式：
      // （1）按级别和-积分和排序，两名同组参赛人员级别之和大的排在前面，级别和相同的情况下，年度积分之和大的排在前面。
      // （2）按级别差-积分和排序，两名同组参赛人员级别之差小的排在前面，级别差相同的情况下，积分之和（
      // 常规赛按照年度积分和计算、月赛按照今天之前30天积分和统计、季赛按照今天之前90天统计、年赛按照今天之前365天统计）大的排在前面。
      //比赛类型(1常规赛，2月度赛，3季度赛，4年度总决赛，5月度赛-资格赛，6月度赛-级别赛)
      if (this.ruleForm.projectType === 3) {
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/getDoubleMatchEnrollListByCtId?ctId=${id}&teamType=0`),
          method: 'get',
        }).then((data) => {
          if (data && data.code === 0) {
            const tempArr = []
            for (let item of data.data) {
              for (let cell of item.elEnrollList) {
                tempArr.push(cell)
              }
            }
            this.enrollData = tempArr
            this.table.data = tempArr
            this.enrollDataOne = []
            this.enrollDataTwo = []
            for (let i of this.table.data) {
              if (i.refundScale === null && i.refundFee !== null) {
                i.refundScale = ((i.refundFee / i.payAmount) * 100).toFixed(2)
              }
              if (i.refundFee === null && i.refundScale !== null) {
                i.refundFee = ((i.payAmount * i.refundScale) / 100).toFixed(2)
              }
              if (i.accountType !== null) {
                i.accountTypeName = { '0': '一般账户', '1': '青少年账户' }[i.accountType]
              }
              if (i.gender !== null) {
                i.genderName = { '0': '男', '1': '女' }[i.gender]
              }
              if (i.memberType !== null) {
                i.memberTypeName = { '1': '注册会员', '2': '初始会员', '3': '荣誉会员' }[i.memberType]
              }
              if (i.mbBirthday) {
                i.birthday = i.mbBirthday
              }
              if (i.birthdays) {
                i.birthday = i.birthdays
              }
              if (i.idCards) {
                i.idCard = i.idCards
              }

              if (i.bench === 0) {
                //主力
                this.enrollDataOne.push(i)
              }
              if (i.bench === 1) {
                //替补
                this.enrollDataTwo.push(i)
              }
            }
          }
        })
      } else {
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/getDoubleEnrollListByCtId`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        if (data && data.code === 0) {
          // console.log('参赛人员列表：', data)
          this.enrollData = data.eoList
          this.table.data = data.list
          this.enrollDataOne = []
          this.enrollDataTwo = []
          for (let i of this.table.data) {
            if (i.refundScale === null && i.refundFee !== null) {
              i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
            }
            if (i.refundFee === null && i.refundScale !== null) {
              i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
            }
            if (i.accountType) {
              let arr = i.accountType.split('/')
              let arrName = []
              arr.forEach((g) => {
                arrName.push({ '0': '一般账户', '1': '青少年账户' }[g])
              })
              i.accountTypeName = arrName.join('/')
            }
            if (i.gender) {
              let arr = i.gender.split('/')
              let arrName = []
              arr.forEach((g) => {
                arrName.push({ '0': '男', '1': '女' }[g])
              })
              i.genderName = arrName.join('/')
            }
            if (i.memberType) {
              let arr = i.memberType.split('/')
              let arrName = []
              arr.forEach((g) => {
                arrName.push(
                  { '1': '注册会员', '2': '初始会员', '3': '荣誉会员' }[g]
                )
              })
              i.memberTypeName = arrName.join('/')
            }
            if (i.mbBirthday) {
              i.birthday = i.mbBirthday
            }
            if (i.birthdays) {
              i.birthday = i.birthdays
            }
            if (i.idCards) {
              i.idCard = i.idCards
            }

            if (i.bench === 0) {
              //主力
              this.enrollDataOne.push(i)
            }
            if (i.bench === 1) {
              //替补
              this.enrollDataTwo.push(i)
            }
          }
        }
      })
      }
    },
    checkAll(val) {
      this.nowSelectData = val
    },
    checkRightAll(val) {
      this.nowSelectRightData = val
    },
    // 选中
    handelSelect() {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftData)
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect() {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      )
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
      this.nowSelectRightData = []
    },
    handleConcatArr(rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getLeftData()
    },
    //主力勾选事件
    enrollOneChange(val) {
      this.enrollDataOneChange = val
    },
    //替补勾选事件
    enrollTwoChange(val) {
      this.enrollDataTwoChange = val
    },
    //导出excel
    exportExcel() {
      let exportData = []
      console.log('表数据：', exportData)
      for (let i of this.table.data) {
        if (i.bench === 0) {
          const player = JSON.parse(JSON.stringify(i))
          if (player.mobile) {
            player.mobile = 'keepString' + player.mobile
          }
          if (player.idCard) {
            player.idCard = 'keepString' + player.idCard
          }
          exportData.push(player)
        }
      }
      if (exportData == null || exportData.length === 0) {
        this.$message.info('没有要导出的数据!')
        return
      }
      let columns = this.table.columns
      if (
        this.ruleForm.orderForm == 1 ||
        (this.ruleForm.orderForm == 2 &&
          (this.ruleForm.ctType == 1 || this.ruleForm.ctType == 4))
      ) {
        columns = this.table.columns
      } else if (this.ruleForm.orderForm == 2 && this.ruleForm.ctType == 2) {
        columns = this.table.columnsDoubleMonth
      } else if (this.ruleForm.orderForm == 2 && this.ruleForm.ctType == 3) {
        columns = this.table.columnsDoubleQuarter
      }
      console.log('表头：', columns)
      let title = this.ruleForm.matchName || ''
      this.$export
        .excel({
          columns: columns,
          data: exportData,
          title: title + '参赛人员'
        })
        .then(() => {
          this.$message.success('导出表格成功')
        })
    }
  }
}
</script>
<style>
.marginBottom {
  margin-bottom: 20px;
}

.headTitle {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.active {
  background: #02b90d !important;
  color: #fff !important;
}

.marginBottom {
  margin-bottom: 20px;
}

.width_label {
  width: 180px;
}

.opSetting {
  text-align: center;
  margin-top: 30px;
}

.spacing {
  margin-top: 10px;
}

.font_label {
  font-weight: bold;
  font-size: 18px;
}

.el-radio.is-bordered {
  width: 141px;
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}
</style>
